import React, { useState } from "react";
import { ActionPanel } from "components/panel";
import { Button } from "components/buttons";
import { LicenceCheckingNewConsentModal } from "pages/licence-checking/shared/new-consent";
import PropTypes from "prop-types";

export function RefusedDriverDeclarationPanel({ checkData, reloadCheck }) {
    const [showModal, setShowModal] = useState(false);

    function handleSuccess() {
        setShowModal(false);
        reloadCheck();
    }

    return (
        <div className="spacer-top">
            <ActionPanel intent="warning" title="Refused Driver Declaration">
                <div>
                    <p className="spacer-bottom">
                        This employee has refused the driver declaration for the
                        Licence Checking part of this Grey Fleet Check. To
                        restart the process please click the button below.
                    </p>
                    <Button
                        id="add-question-type"
                        onClick={() => setShowModal(true)}
                        text={"Restart Declaration"}
                        icon="reset"
                        intent="Primary"
                    />
                </div>

                <LicenceCheckingNewConsentModal
                    isOpen={showModal}
                    employeeId={checkData?.employeeId}
                    emailAddress={checkData?.emailAddress}
                    employeeName={checkData?.employeeName}
                    onSuccess={handleSuccess}
                    onClose={() => setShowModal(false)}
                    consentExists={true}
                />
            </ActionPanel>
        </div>
    );
}

RefusedDriverDeclarationPanel.propTypes = {
    checkData: PropTypes.object.isRequired,
    reloadCheck: PropTypes.func.isRequired,
};
